/* eslint-disable @typescript-eslint/naming-convention */
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { RefObject, useEffect, useState } from 'react';
import { SIDEBAR_WIDTH, Sidebar } from './Sidebar';

interface BurgerMenuProps {
  anchorRef: RefObject<HTMLDivElement>;
}

export const BurgerMenu = ({ anchorRef }: BurgerMenuProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const onDrawerClose = () => setIsDrawerOpen(false);
  const onDrawerOpen = () => setIsDrawerOpen(true);

  useEffect(() => {
    if (isDesktop && isDrawerOpen) setIsDrawerOpen(false);
  }, [isDesktop, isDrawerOpen]);

  if (isDesktop) return null;

  return (
    <>
      <div ref={anchorRef} style={{ position: 'absolute', top: 0, left: 0 }} />
      <IconButton onClick={isDrawerOpen ? onDrawerClose : onDrawerOpen}>
        {isDrawerOpen ? (
          <CloseIcon sx={{ color: theme.palette.common.black }} />
        ) : (
          <MenuIcon sx={{ color: theme.palette.common.black }} />
        )}
      </IconButton>
      <Drawer
        anchor="left"
        open={isDrawerOpen}
        onClose={onDrawerClose}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: {
            width: SIDEBAR_WIDTH,
            top: theme.appbar.mobileHeight,
            height: `calc(100% - ${theme.appbar.mobileHeight}px)`,
          },
        }}
      >
        <Sidebar onLinkClick={onDrawerClose} />
      </Drawer>
    </>
  );
};
